export default __webpack_public_path__ + "static/views-management-1bb99c3702f73952510e22ffda729edd.png";